import { type GA4PageNameType } from '@/ga4types'
import analytics from '@/shared-utils/analytics'

import { GA4TripTypeMapper } from '../BundleAndSave/utils'
import type { HOTEL_FORM_PREFILL_ANALYTICS, HOTEL_FORM_STATE_TYPE } from './types'

export default function fireHotelSubmitEvent(
  initialState: HOTEL_FORM_STATE_TYPE,
  submittedState: HOTEL_FORM_STATE_TYPE,
  pageName: GA4PageNameType,
  itemName?: string,
  prefill?: HOTEL_FORM_PREFILL_ANALYTICS,
) {
  const isBundled = submittedState.tripType.includes(':')
  // Pre-filled values were not entered by the user, so a change means they differ from what the form
  // showed, not from the empty form.
  const baseline = prefill?.baseline ? { ...initialState, ...prefill.baseline } : initialState
  const hasAiFilters = Boolean(submittedState?.endLocation?.filters?.length)
  // A pre-filled destination that was left alone: the city fields say nothing about this search, so
  // they are left off the event. `ai_query` keeps its usual shape.
  const isPrefilledForm = !hasAiFilters && (prefill?.isDestinationPrefilled ?? false)
  analytics.fireGA4Event({
    event: 'search',
    attributes: {
      date_change:
        baseline.startDate !== submittedState.startDate || baseline.endDate !== submittedState.endDate
          ? 'y'
          : 'n',
      ...(isPrefilledForm
        ? {}
        : {
            trip_start_city_change: initialState.startLocation !== submittedState.startLocation ? 'y' : 'n',
            trip_end_city_change: initialState.endLocation !== submittedState.endLocation ? 'y' : 'n',
          }),
      quantity_change:
        baseline.travelers.adults !== submittedState.travelers.adults ||
        baseline.travelers.children !== submittedState.travelers.children ||
        baseline.travelers.rooms !== submittedState.travelers.rooms
          ? 'y'
          : 'n',
      page_name: pageName,
      product_name: 'hotel',
      type: hasAiFilters ? 'ai_query' : isPrefilledForm ? 'prefilled_form' : undefined,
      ...(itemName ? { item_name: itemName } : {}),
      bundle_flag: isBundled ? 'y' : 'n',
      ...(isBundled ? { bundle_type: GA4TripTypeMapper(submittedState.tripType) } : {}),
    },
  })
}

export function fireBundleAndSaveEvent(tripType: string) {
  const mappedTripType = GA4TripTypeMapper(tripType)
  analytics.fireGA4Event({
    event: 'select_promotion',
    attributes: {
      type: 'add_on',
      product_name: 'hotel',
      bundle_flag: 'y',
      bundle_type: mappedTripType,
    },
  })
}

export function fireMultiHotelRadioClick(pageName: 'homepage' | 'landing') {
  analytics.fireGA4Event({
    event: 'select_promotion',
    attributes: {
      type: 'package',
      page_name: pageName,
      product_name: 'hotel',
      bundle_flag: 'y',
      bundle_type: 'hh',
    },
  })
}
